import { render, staticRenderFns } from "./NewsSection.vue?vue&type=template&id=a69aec12&scoped=true&"
import script from "./NewsSection.vue?vue&type=script&lang=js&"
export * from "./NewsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69aec12",
  null
  
)

export default component.exports